<template>
    <section class="content">
      <div class="box box-info">
        <div class="p-toolbar p-component mb-4">
          <crmFollowUpDetailsDialog ref="openDialog" :showNewButton="true"/>
        </div>
        <!-- <a href="#"  @click.prevent="exportCSV()" v-if="this.crmFollowSamleLists.length > 0">
          <img src="../../../../static/img/excel.png" style="margin-top: 1em;width: 4%;float: right;"/>
        </a> -->
        <DataTable ref="po"
          :value="crmFollowSamleLists"
          :paginator="true"
          :rows="100"
          :rowsPerPageOptions="[100, 500, 1000]"
          :filters="filters"
          class="p-datatable-responsive p-datatable-customers"
          :selection.sync="selectedProduct1" selectionMode="single"
        >
        <template #header v-if="this.$store.getters.modules.includes('5.38')">
            <div style="text-align: left">
              <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
            </div>
          </template>
          <Column header="S.n">
            <template #body="slotProps">
            {{slotProps.index+1}}
            </template>
          </Column>
          <Column :sortable="true" header="Particular" field="particular" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['particular']" />
            </template>
          </Column>
          <Column :sortable="true" header="Client Name" field="clientName" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['clientName']" />
            </template>
          </Column>
          <Column :sortable="true"
            header="Contact Person"
            field="contactPerson"
            filterMatchMode="contains"
          >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['contactPerson']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Address" field="address" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['address']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Contact Number" field="contactNumber"
            filterMatchMode="contains" >
            <template #body="slotProps">
          {{ formatContactNumber(slotProps.data.contactNumber) }}
        </template>
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Email" field="gmail" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['gmail']" />
            </template>
          </Column>
  
          <!-- <Column :sortable="true" header="Product" field="products" filterMatchMode="contains">
            <template #body="slotProps">
                <span>{{ slotProps.data.products.join(', ') }}</span>
            </template>
            <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['products']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Rate" field="rate" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['rate']" />
            </template>
          </Column> -->
  
          <Column :sortable="true" header="Customer Type" field="customerType" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['customerType']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Priority" field="priority" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['priority']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Stage" field="stage" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['stage']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Sample Sent" field="sampleQuotationSent" filterMatchMode="contains" >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['sampleQuotationSent']" />
              </template>
              <template #body="slotProps">
    {{ slotProps.data.sampleQuotationSent ? 'Yes' : 'No' }}
  </template>
            </Column>

            <Column :sortable="true" header="Sample Sent Date" field="sampleDateNepali" filterMatchMode="contains" >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['sampleDateNepali']" />
              </template>
            </Column>
  
            <!-- <Column :sortable="true" header="Quotation Sent" field="quotationSent" filterMatchMode="contains" >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['quotationSent']" />
              </template>
            </Column> -->
  
          <!-- <Column :sortable="true" header="Remarks" field="remarks" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['remarks']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Remarks 1" field="remarks1" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['remarks1']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Remark 2" field="remark2" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['remark2']" />
            </template>
          </Column> -->
          <Column :sortable="true" header="Remarks-Product-Rate" field="remarks" filterMatchMode="contains" >
            <template #body="slotProps">
            <Button icon="pi pi-eye" class="p-button-raised p-button-success" @click="openRemarks(slotProps.data)" />
            </template>
        </Column>
  
          <Column :sortable="true" header="Updated Date Np" field="updateDateNepali" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['updateDateNepali']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Next Follow Up Date Np" field="nextFollowUpDateNepali" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['nextFollowUpDateNepali']" />
            </template>
          </Column>
  
          <Column header="Enter By" :sortable="true" field="enterBy" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['enterBy']"/>
                  </template>
          </Column>
             <Column header="Update By" :sortable="true" field="updatedBy" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['updatedBy']"/>
                  </template>
            </Column>
            
          <Column header="Action" headerStyle="width: 11em">
            <template #body="slotProps">
              <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editCrmFollowUp(slotProps.data)" />
              <!-- <Button icon="pi pi-trash" class="p-button-danger p-button-sm" @click="openDialog(slotProps.data.id)"/> -->
            </template>
          </Column>
        </DataTable>
      </div>
      <remarksDialog
    :visible="dialogVisible"
    :style="{ width: '500px' }"
    :header=clientName
    :modal="true"
    class="p-fluid"
  >
  <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-6">
        <label for="productName">Products <span style="color:red"></span></label>
        <Textarea
          id="productName"
          v-model="productName"
          rows="2"
          autoResize
        />
      </div>

   
      <div class="p-field p-col-12 p-md-6">
        <label for="rate">Rate <span style="color:red"></span></label>
        <Textarea
          id="rate"
          v-model="rate"
          rows="2"
          autoResize
        />
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-6">
        <label for="remarks">Remarks <span style="color:red"></span></label>
        <Textarea
          id="remarks"
          v-model="remarks"
          rows="3"
          autoResize
        />
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="remarks1">Remarks 1</label>
        <Textarea
          id="remarks1"
          v-model="remarks1"
          rows="3"
          autoResize
        />
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="remarks2">Remarks 2</label>
        <Textarea
          id="remarks2"
          v-model="remarks2"
          rows="3"
          autoResize
        />
      </div>
    </div>
    <template #footer>
      <Button
        label="Close"
        icon="pi pi-times"
        class="p-button p-button-raised p-button-danger"
        @click="closeRemarks"
      />
    </template>
  </remarksDialog>
      <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteCrmFollowUp"/>
    </section>
  </template>
  
  <script>
  import crmFollowUpDetailsDialog from '../crmDialog/crmFollowUpDetailsDialog.vue'
  import Column from 'primevue/column'
  import DataTable from 'primevue/datatable'
  import Dialog from '../../layout/dialog'
  // import globalKey from '../../../store/globalKey'
  // import axios from 'axios'
  import InputText from 'primevue/inputtext'
  import Button from 'primevue/button'
  import Textarea from 'primevue/textarea'
  import remarksDialog from 'primevue/dialog'
  export default {
    name: 'crmFollowSamleList',
    data() {
      return {
        displayBasic: false,
        dialogShow: false,
        selectedProduct1: null,
        dialogVisible: false,
        columnList: '',
        accountId: null,
        filters: {}
      }
    },
    computed: {
      crmFollowSamleLists() {
        return this.$store.state.crm.crmFollowSamleLists
      }
    },
    mounted() {
      this.crmFollowSamleList()
      this.columnNames()
    },
    methods: {
      async deleteCrmFollowUp(value) {
        if (value.trim() === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
          this.dialogShow = true
          return
        }
        let deleteRe = {
          id: this.accountId,
          deleteReason: value
        }
        let resp = await this.$store.dispatch('deleteCrmFollowUp', deleteRe)
        if (resp.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
          this.closeDialog()
          this.dialogShow = false
          await this.crmFollowSamleList()
        } else {
          this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
          this.dialogShow = false
          this.closeDialog()
        }
      },
      editCrmFollowUp(data) {
        this.$refs.openDialog.editCrmFollowUp(data)
      },
      openRemarks(data) {
        this.remarks = data.remarks
        this.remarks1 = data.remarks1
        this.remarks2 = data.remark2
        this.dialogVisible = true
        this.clientName = data.clientName + '  Remakrs'
        this.productName = data.products.join(', ')
        this.rate = data.rate
      },
      closeRemarks() {
        this.dialogVisible = false
      },
      exportCSV() {
        this.$refs.po.exportCSV()
      },
      // exportCSV() {
      //   let data = {
      //     columnList: this.columnList
      //   }
      //   axios({
      //     url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/CRM Follow-up List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
      //     method: 'get',
      //     headers: {
      //       'Accept': 'application/vnd.ms-excel',
      //       'Authorization': localStorage.token
      //     },
      //     responseType: 'blob'
      //   }).then((response) => {
      //     const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
      //     const link = document.createElement('a')
      //     const contentDisposition = response.headers['content-disposition']
      //     let fileName = 'crmFollowSamleList.xlsx'
      //     if (contentDisposition) {
      //       const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
      //       if (fileNameMatch && fileNameMatch.length === 2) {
      //         fileName = fileNameMatch[1]
      //       }
      //     }
      //     link.href = url
      //     link.setAttribute('download', fileName)
      //     document.body.appendChild(link)
      //     link.click()
      //     link.remove()
      //     window.URL.revokeObjectURL(url)
      //   })
      // },
      columnNames() {
        this.columnList = ''
        for (let i = 0; i < this.$refs.po.columns.length; i++) {
          if (this.$refs.po.columns[i].header && this.$refs.po.columns[i].header !== 'Action' && this.$refs.po.columns[i].header !== 'S.n') {
            this.columnList += this.$refs.po.columns[i].header + ','
          }
        }
        this.columnList = this.columnList.slice(0, -1)
      },
      async crmFollowSamleList() {
        // let res = await this.$store.dispatch('loadAllSampleSentFollowUpList')
      },
      formatContactNumber(num) {
        if (!num) return ''
        const clean = num.toString().replace(/\D/g, '').substring(0, 10)
        return clean
      },
      openDialog(id) {
        this.dialogShow = true
        this.accountId = id
      },
      closeDialog() {
        this.dialogShow = false
      },
      cancel() {
        this.dialogShow = false
      }
    },
    components: {
      Column,
      DataTable,
      Dialog,
      InputText,
      crmFollowUpDetailsDialog,
      Button,
      Textarea,
      remarksDialog
    }
  }
  </script>



// WEBPACK FOOTER //
// sampleSent.vue?7529801f